<router-outlet></router-outlet>
<y-global-toast></y-global-toast>
<y-spinner></y-spinner>